// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d61cb78f","455":"da828f02","884":"9d9a9c07","977":"5175217a"}[chunkId] + ".chunk.js";
};